import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { InputDatepicker } from 'src/app/core/Models/interfaces/input-datepicker';
import { DatepickerService } from '../service/datepicker.service';
import { TimerComponent } from '../timer/timer.component';


@Component({
  selector: 'app-datePicker-NoRange',
  templateUrl: './datePicker-NoRange.component.html',
  styleUrls: ['./datePicker-NoRange.component.css', '../date-time-picker.component.css'],

})
export class DatePickerNoRangeComponent implements OnInit, AfterViewInit {
  @Input() field!: InputDatepicker
  @Input() form: any;
  @Input() formName:string='';
  @ViewChild(TimerComponent) timerCmp !: TimerComponent;
  @Input() isInValid: boolean = false;
  @Input() disabled: boolean = false;
  @Input('isEdit') isEdit: boolean = false;
  constructor(public datepicker_serv: DatepickerService) { }


  months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  weekdays = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"]
  year!: number
  today = new Date()
  month!: number
  days!: any[];
  formvalue:any;
  selectedDates: Date | null = null;
  activeDate: Date | null = null;
  timeSeleted: string = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  @ViewChild('main') mainrEF!: ElementRef
  @ViewChild('showyear') showyearREF!: ElementRef
  @ViewChild('showallmonth') showallmonthREF!: ElementRef
  @ViewChild('DAYS') daysREF!: ElementRef
  @ViewChild('MONTH') monthREF!: ElementRef
  @ViewChild('datepicker') datepickerREF!: ElementRef




  mainele!: HTMLElement
  showyearELE!: HTMLElement
  showallmonthELE!: HTMLElement
  daysELE!: HTMLElement
  monthELE!: HTMLElement
  datepickerELE!: HTMLElement


  ngAfterViewInit(): void {
    this.mainele = this.mainrEF?.nativeElement
    this.showyearELE = this.showyearREF?.nativeElement
    this.showallmonthELE = this.showallmonthREF?.nativeElement
    this.daysELE = this.daysREF?.nativeElement
    this.monthELE = this.monthREF?.nativeElement
    this.datepickerELE = this.datepickerREF?.nativeElement
    this.formvalue=this.form.controls[this.formName].value;

    document.addEventListener('click', (e: Event) => {
      if (!e.composedPath().includes(this.datepickerELE)) {
        if (this.mainele != null) {
          if (this.mainele?.classList.contains('active')) {
            this.mainele?.classList.remove('active');
          }
        }
      }
    });
  }
  setdate() {    
    if (this.activeDate) {
      let formattedDate=this.transform(this.activeDate)
      if(this.field.timer) this.form.get(this.formName).patchValue(formattedDate+'---'+this.timeSeleted);
      else this.form.get(this.formName).patchValue(formattedDate);
    }
    else{
      this.form.get(this.formName).patchValue(null);
    }
  }
  transform(value: Date) {
    if (this.field.locale != undefined) {
      return value.toLocaleDateString(this.field.locale, this.field.options)
    } else {
      let language = window.navigator.language || window.navigator.language;
      return value.toLocaleDateString(language, this.field.options)
    }
  }

  ngOnInit() {
    this.datepicker_serv.year.subscribe(
      (x: number) => {
        this.year = x;
        this.datepicker_serv.month.subscribe(
          (x: number) => {
            this.month = x;
            this.days = this.datepicker_serv.generateDays(this.year, this.month)
            if (this.selectedDates != null)
              this.selectedDates = new Date(this.year + '-' + (this.month + 1) + '-' + this.selectedDates.getDate())
          }
        )
      }
    )
    
  }
  toggleDatePicker(e: Event) {
    if (!this.checkEventPathForClass(e?.composedPath(), 'main')) {
      this.mainele?.classList?.toggle('active');
      this.showyearELE?.classList.remove('active');
      this.showallmonthELE?.classList.remove('active');
      this.daysELE?.classList.remove('inactive');
      this.monthELE?.classList.remove('inactive');
      if (this.activeDate == null) {
        this.datepicker_serv.changeMonth(this.today.getMonth(), this.today.getFullYear())
      } else {
        this.datepicker_serv.changeMonth(this.activeDate.getMonth(), this.activeDate.getFullYear())
      }
    }
  }
  checkEventPathForClass(path: any, selector: any) {
    for (let i = 0; i < path.length; i++) {
      if (path[i].classList && path[i].classList.contains(selector)) {
        return true;
      }
    }

    return false;
  }
  change() {
    this.datepicker_serv.changeMonth(this.month, this.year)
  }

  nextMonth() {
    if (this.month < 11) {
      this.month = this.month + 1;
    } else {
      this.month = 0
      this.year += 1
    }
    this.change()
  }
  prevMonth() {
    if (this.month > 0) {
      this.month = this.month - 1;
    } else {
      this.month = 11
      this.year -= 1
    }
    this.change()


  }
  selectedDate(day: any, event: any) {
    if (day.isMonth === false) {
      this.datepicker_serv.changeMonth(day.date.getMonth(), day.date.getFullYear())
    }
    this.selectedDates = new Date(day.dateTxt)
    this.activeDate = this.selectedDates
    this.formateDate(this.selectedDates);
    this.setdate();
    this.datepickerELE.click()
  }

  formateDate(date: Date) {
    let day: any = date.getDate();
    if (day < 10) day = "0" + day
  }

  // selectMonth(e: Event) {
  //   if (!this.checkEventPathForClass(e.composedPath(), 'days')) {
  //     (document.querySelector('.days') as HTMLElement).classList.toggle('inactive');
  //     (document.querySelector('.showallmonth') as HTMLElement).classList.toggle('active');
  //   }
  // }
  monthSelected(e: Event) {
    this.daysELE.classList.toggle('inactive');
    this.showallmonthELE.classList.toggle('active');
  }
  selectYear(e: Event) {
    this.daysELE.classList.add('inactive');
    this.monthELE.classList.add('inactive');
    this.showyearELE.classList.toggle('active');
    this.showallmonthELE.classList.remove('active');

  }
  yearSelected(e: Event) {
    this.showallmonthELE.classList.toggle('active');
    this.showyearELE.classList.toggle('active');
    this.monthELE.classList.remove('inactive');
  }

  reset() {
    if(this.isEdit){
      this.form.controls[this.formName].patchValue(this.formvalue);
      this.datepickerELE.click();
      
    }else{
    this.activeDate = this.selectedDates = null;
    this.setdate();
   if(this.field.timer){
    this.timeSeleted = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    this.timerCmp.reset();
   }
   
    this.datepickerELE.click()
  }
  }
  selectedTime(event: string) {
    this.timeSeleted = event
  }



}
